<template>
	<div class="tabbar-container">
		<div class="tabbar-item" 
			v-for="(item, index) in navList" 
			:key="index"
			:class="{ 'active': currentPath == item.path, 'center-button': item.isCenter }"
			@click="gopage(item.path)">
			<div class="tab-icon" :class="{ 'center-icon': item.isCenter }">
				<!-- 市场图标使用base64 PNG -->
				<img v-if="item.path === '/market'" 
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABMZJREFUaEPtWV1oHFUUPmd2Cg20oFBxNz5YIQ8WFCpa6IOiRUVFHxJaUWkEwc3cCStpgxZbUByhYkEhLTjs3NmUVlBQWrGFBZUqKNYHsaLgyz4UTKFkFuyDYEiz2Zm97g13wnUyv9nZxsDu2+6cc+/33XPmfuecRdjkH9zk+GFAYKMjmHsEDMNQS6XSQQAYB4DdjDEXEX9njJ1tNpsXDcNYypN0rgRqtdqdnuddQMS9ESAvt1qtl6ampq7nRSI3ArOzs3d7nvc9AOxMADdXKBQeK5fL1/IgkQuBWq32oOd5dUQsclAibY53Op2P+XdFUQ4yxgxEVAXo64qijE5MTPzaK4meCdi2/RRj7DwAbBNglro5P6pp2jcyOGF3AQC2xtllJdQTAcuyXkDEsxKoG4h4QNO0H8KA2Lb9qCC7QyIxrmnaF1mB+/brJmDb9puMsRP+QoyxOc/znqxUKlfjwJimOVIoFC51icvvyluEkPfWQ2JdBCil7wPAUWnDRqfTeWZycnIuDYhqtbpTUZSvAODe1ZNEPK5p2ttp/GWbTAQMw9haKpXOAMCL0iLfuq47VilUFrJsbprmNlVVvwSAJyQS5+fn51/OohWpCYgNzwHA01La1JvN5vNZNpRJ8gMpFovnEPE56fevHccZS7tmKgJcoDqdTh0AHpI2Ouk4zhHDMNwsJx+0Fcr9AQAclg7myvLy8lgawUskECFQBiHk3V6AB30ppe90fzOk31MJXiyBMIECAF3X9dN5gvfXsizrVQCwsgheJIG0ApU3kayCF0qAUvosAHB1XVFNxlhTVdUD5XL5p7wBZxC8NerOfdcQEDnfkMCnEqi8iYUI3pLruvcHhXINAUrpjHQjXG21WvvS3AZ5E+DrCcG7BAAjK6eNaGmaNhkrZJTSP6WSeC8h5Od+gEu7pqifeJnOP3OEkHuSCDDfwHGcLb3e82mBRtkJnWj7z7vX93+yJiyFVgkEjePAVKvVuxRFeQ0ARhljI9JVuOImegT+btVd1z1VqVSaacl1NSISUy4EbNvmDYsl9QRJ2Ja61esruq5/nmTIn/eVgOgJPksDJGiDiLwX+DTJt28ETNMsqqrKX3q/y+Ip8objON8FizFeDBYKhccRkfcQfhm90Gq1diXdcn0jEOgLGq7r7kkqq0VV+4tE4gQh5FhcFPpGwLKsPxDxPr65aNIvJqWDyGmu9Ly65Z8GIWTXRhFo+7eN67rbk07fBykao5v+7aTr+pYNIRAX2qRIZPHtWwplAREklMV3QCAqHbKc4iAC4gRyrYUGEYg41Szp1lMx93+NABeYldpmcXHx9unp6b9jXuJVWwC4gxByI+n+F0rMh7t/CSFb0HV9e5SfKD3+iRK9sAj8xv8aEg7luBEKpfRHAHhY2NY9z5tIqvMppTsYY2ekadxlQsgjUQRs2z7EGDspnl8hhOyRbcMIvN6t6z8URnzWf7Tdbp8OKxNs294vxuVpDj7UJqqGmpmZuW1oaGg/In7kZwQiHtY07VQsAVGn8CisTo7XjS5fx4bjOA8Ey/TQuVDY+DtfLJlXixzfR07meCSGh4cJY2ycMbY72ONmhpDdgf8dyxukTxzHMaOm1YnD3ez73lqPAYFbe95rd9v0EfgXsFbQT3YQwnYAAAAASUVORK5CYII=" 
					:alt="item.name"
					class="custom-icon market-icon"
					:class="{ 'active-icon': currentPath == item.path }">
				<!-- 订单图标使用base64 PNG -->
				<img v-else-if="item.path === '/orders'" 
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAcFJREFUaEPtWTtOxDAQtaWtUlFQUFJwkL3HIkEVKxVHYDlBaFLYFUhwj+32EhScJCaWIhQl9u7MeDAOOPX4zbz5eTyRYuWfXLn9IkigbduLqqp2QojLhCQ/lVKvGH1eAl3XXW02m6MQ4hoDxiErpbyt6/odiuUlYIx5sNY+Q0GY5fZKqScoppeA1vpxANg7EGvtQUp5gAJS5AYd20HHdjzLS8ARwXiEQmDqMKy+sxHAAmZPwBizs9beUAwNnZmmUCBlg90JFQGt9d3QmV44jYdihboTlsB3cUMVM8p5a5FMIJfuRCaQS3EXAow5voCC3A8lAiUCJzxQUmg+HUI8wplSEH3sRUyclbyzTnICMbOSb9ZJTmD0/hsxje7n7+HkBJzhYxRQb+m+7z+aplm8g3+FANH73mOFwL9so6tPoXIPTEKYvIjLPTAroOQR4Czg8VKcbkF4txLlUQ8IV0kh56TpAitmDQ5w+I9tJUK6s1i7h/7QuA30ubk+XwKhuX41KRTKGUhXoOR6jD7Uf+I/RSDr9TowpJzZAsGCjxIhtMhpE2LkKZnF1sIJo2qAunWItTy0tSARiDWG+zw6AtwGxOJ9AZzEfE+wKJ6HAAAAAElFTkSuQmCC" 
					:alt="item.name"
					class="custom-icon orders-icon"
					:class="{ 'active-icon': currentPath == item.path }">
				<!-- 交易图标使用base64 PNG -->
				<img v-else-if="item.path === '/trading'" 
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAoVJREFUaEPtmr2O00AQx3e0KSjuASiv4B3uJK6ggA4KSsQhDinKbJQGBBJ0HB1IIGgS7USRCOIQJQV0XEEBAt7hiit5gCsoYi/2aVeynHUSf6x3I+LW453/b8Y7O/IY2JpfsOb62QbAdwYXZoCIdpRSVwDggiehZ5zzX91u90eRfyvAcDjc4px/BIDrnoTn3R7PZrObg8HgLH/DCkBEXxljVwMRfy5DKfVFCHFjKcBkMrkcRdH3jOERY+zEB4xSahsADjK+dxHxd1bLXAaI6CFj7KWmngoh7vkQb3wS0fskgPtazxMhxItlAE8Tg0NtdIiIzzwDLNRjy8AGoMmMEZH/DIzH49tKqQ4ivisL5x2AiO4yxqZa+BtEfFAGwjuAjn5ais1VCsI7QKpaSvkaAO5XgQgCoA5EMABVIYICqALhDEBvzktlKoqxVUoJALi4yp5wApArjVUY5p4BgP1er/chf8MJgKU0NgFxYDvonACkanUWtptQHsfxSb/fn4u+9uO/lagD6SwDdUSVedYZQJ0qZAE4LWr0nABsqpD9HWq3CuUbtORw+pMcTrLM+21svVWhOl3mqqBO9kDWuWsI5wBVGrRVo9/qQeYqE61kwEQ0D1HUoAWZgQIIa2kMGsA0enEcz4oatOAByghcZtvqHlgmpsr9/w9ASvk4GSk919E6QsQ7VSLX1DNSyreZGcEjRHyVXXvu6/RoNNrlnP80RsmQYZoscNqUoJLrpB8NzmcD6cU538vPy6wjJinl54DmY0b/MSJeywegcMjX6XQ+hTInS+djURTdWnnIZyiJaI8xtpOMnLZKpr4Rc6XUXwD4lp+LLdwDjXhucZHNrwYtBtvqau0z8A/SbSFPGedPZQAAAABJRU5ErkJggg==" 
					:alt="item.name"
					class="custom-icon trading-icon"
					:class="{ 'active-icon': currentPath == item.path }">
				<!-- 理财图标使用base64 PNG -->
				<img v-else-if="item.path === '/newtrading'" 
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAn9JREFUWEftmTFoFEEUht9blsM7LBJQiJ2FATvTiI0BCwsLC8HS6kDmLZxgDiMoKBIUFIxcBA92FsHKwkKwSBHBIqCN2GgnmMJOQcEUYQl3yz5vZBZ2j7s4490mOZntlpv3z7dv/n2zbw5hwi6cMF74/4GjKLqUpukVRDxe4up8B4C1OI6Xms3mZn4eqwyHYfgQERdLBO2X3ojj+GQe2hg4DMMTiPhxF2GzqR4Q0c3sxgb4LiLe0oFrSZLUO53OdhkPUK1WLyLiU629QUSz1sBSyhYALKhARFwQQjwuA1ZptlqtqVqt9kvrbxLRtAMeZ7atMyylPIWI55n5YA7kDADMaUusM/NILyAifu12uy8ajYYqYYXLCniXS9d2r/JcEEK8zhMbA0spCQDCcS6vgdZWkiSz+UzbAL8FgNNqEmZe9TzvjcGE1kOY2WdmtVse1cGLRPQoE7IB/gEAh1RgkiRHBvnLmm5IgJTyGgAs659XiKj5L8Cq9k2pwEqlMl2v1wv7+LhglU4URVeZecUBjzOreS2XYefhPm85SzhLOEsAgJTS7XTDNh5XJVyVsKgS7XZ7xvf9bzrkJxEdHtg179VLh4jrvX7xVQaVpulZ1VPq+3dENL+vgP/yRRgQkZwI4F7XvhwEwfX8AxWOqvbKEgCgjgyULf5czLyFiKtE9L4/+/sFuNDT7WQRB2zaUu2009lk+AsAHFMBnudd9n3/pSmAzbg4jg/4vv8MAM6pOES8J4S4baLRb4n7AHDDJHCcY5h5LgiCTyaaBWB94vIhy7KJwKhjBpUuY0uogRr6jl6umVGBhsUz82fP854IIZ7bzGH8l4GNaJljHXCZ2VXavwERDTdLqdBkNgAAAABJRU5ErkJggg==" 
					:alt="item.name"
					class="custom-icon financial-icon"
					:class="{ 'active-icon': currentPath == item.path }">
				<!-- 个人中心图标使用base64 PNG -->
				<img v-else-if="item.path === '/profile'" 
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAl1JREFUaEPtmjFLHEEUx98wV1hYxj5FvoOCFhZaGYuUgoKBgzdwpBCFpNN0CSRg4R3z4CBChJQWiZUWForJd7CwN6VFilsmu7AHy7q3M7Mzs3ow1968mf/vzdv577w7BlP+YVOuHyLAU+9g7Q4Q0bxSapkxNtOi0AfO+e9ut3ttsmYlQL/fn+Wc/2CMvTaZJNCYi9Fo9KbX6z3UzV8JQETnALASSJjxtEqpX0KIdSuA4XC4mCTJVSHoBABujVd1HKiUeskY2y5Ms4CIfyZN+2gHiGgXAL5kAelkx0KIt46arMOJ6HuatM1cwwchxGcbgP108EEecICIH60VOAYQkbGGqh0wDnbUOTE8AsQScqytZ1NCTZ08d//lPA9HiPiu1VMogJNPdOUgp1AIJ5/kyt4BfDq5iSt7B/Dt5DpXDgHg1Qh1J1IEKB9vuozZWoRuvtZ3gIjWAOA4B9lGxLM6qOcIcA8AL3LRfxFxLgIUM6DbMl0N6+KnvoR0CbA9FFp/iCNA6YrrfQeklO/TRtinPNMniLhlm/XieCnlt0KXYg8Rvxa/9w4wGAwWOOc340WyzkYq4K4hxKtxdyKL55wvlTt23gGyhaSUPwN09S4QcbWciCAA2YWm0+mc+uruZXeBJEk2qtqMQQDGWSKiJQCYTxtlszYlVLpSHiLiTqtXShuxVWN1Zhj0IXYVn8VHgNjYcqwjpxLy7aRNWHTuW/sQe3bSJvq17lsLENBJm8BUuq8WwLeTNlFe575aAFcnbSK48PL3jzF2Wfe7mDGAi5C2YuNfDdrKtPHL3FMLsl3/P1BoC09xhlvaAAAAAElFTkSuQmCC" 
					:alt="item.name"
					class="custom-icon profile-icon"
					:class="{ 'active-icon': currentPath == item.path }">
				<img v-else :src="currentPath == item.path ? item.activated : item.icon" :alt="item.name">
			</div>
			<div class="tab-text" v-if="!item.isCenter">{{ item.name }}</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from "vuex";
	export default {
		data() {
			return {};
		},
		mounted() {},
		computed: {
			...mapState(["footerWhiteList"]),
		navList() {
			return [
				// 1. Market (行情)
				{
					name: this.$t('navTab.tabMenu2') || 'Market',
					path: '/market',
					icon: require('@/assets/img/hq1@3x.png'),
					activated: require('@/assets/img/hq2@3x.png'),
					isCenter: false
				},
				// 2. Orders (订单)
				{
					name: this.$t('order.rw2') || 'Orders',
					path: '/orders',
					icon: require('@/assets/img/dd1@3x.png'),
					activated: require('@/assets/img/dd2@3x.png'),
					isCenter: false
				},
			// 3. 交易按钮 (普通按钮)
			{
				name: this.$t('navTab.trading') || 'Trade',
				path: '/trading',
				icon: require('@/assets/img/jy2@3x.png'),
				activated: require('@/assets/img/jy2@3x.png'),
				isCenter: false
			},
				// 4. Financial (理财) - 新增
				{
					name: this.$t('navTab.financial') || 'Financial',
					path: '/newtrading',
					icon: require('@/assets/img/zx1@3x.png'),
					activated: require('@/assets/img/zx2@3x.png'),
					isCenter: false
				},
				// 5. Mine (我的)
				{
					name: this.$t('navTab.tabMenu6') || 'Mine',
					path: '/profile',
					icon: require('@/assets/img/wd1@3x.png'),
					activated: require('@/assets/img/wd2@3x.png'),
					isCenter: false
				},
			]
		},
			// isShowNav() {
			//   return this.footerWhiteList.includes(this.currentRouteName);
			// },
			// 获取当前路由路径
			currentPath() {
				// //console.log(this.$route);
				// 获取子路由之前的路径 /profile/balance 取/profile
				let path = '/' + this.$route.path.split('/')[1];
				return path
			},


		},
	methods: {
		gopage(url) {
			// 避免重复导航到当前路由
			const currentPath = '/' + this.$route.path.split('/')[1];
			const targetPath = '/' + url.split('/')[1];
			
			if (currentPath === targetPath) {
				//console.log('⚠️ 已在当前页面，无需跳转');
				return;
			}
			
			this.$router.push(url).catch(err => {
				// 捕获并忽略导航重复错误
				if (err.name !== 'NavigationDuplicated') {
					// console.error('路由跳转错误:', err);
				}
			});
		},
	},
	};
</script>
<style scoped>
	/* Tabbar 容器 - 参考 st5-h5 样式 */
	.tabbar-container {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 64px;
	background: var(--bg-primary);
	border-top: none;
	display: flex;
	justify-content: space-around;
	align-items: center;
	box-shadow: none;
	z-index: 999;
	padding-bottom: env(safe-area-inset-bottom);
	border-radius: 0;
	transition: background-color 0.3s ease;
	}

	/* Tabbar 项 */
	.tabbar-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		cursor: pointer;
		position: relative;
	}

	/* 中间交易按钮特殊样式 */
	.tabbar-item.center-button {
		flex: 0 0 72px;
		height: auto;
		margin-top: -24px;
		padding-bottom: 8px;
	}

	/* 图标容器 */
	.tab-icon {
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
		position: relative;
	}

	/* 中间按钮图标 */
	.tab-icon.center-icon {
		width: 56px;
		height: 56px;
		background: transparent;
		border-radius: 50%;
		box-shadow: none;
		margin-bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none;
		position: relative;
	}

	.tab-icon.center-icon img {
		width: 56px;
		height: 56px;
	}

	.tab-icon img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		display: block;
	}

	/* 文字标签 */
	.tab-text {
		font-size: 10px;
		color: var(--text-tertiary);
		line-height: 1.2;
		text-align: center;
		font-weight: 400;
		margin-top: 2px;
		transition: color 0.3s ease;
	}

	/* 自定义图标样式 - 未选中时灰色 */
	.tab-icon .custom-icon {
		opacity: 0.4;
		transition: all 0.3s ease;
	}

	/* 自定义图标激活状态 - 隐藏原图标 */
	.tab-icon .custom-icon.active-icon {
		opacity: 0;
	}
	
	/* 市场图标 - 使用伪元素覆盖主题色 */
	.tabbar-item.active .tab-icon:has(.market-icon)::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 28px;
		height: 28px;
		background: var(--primary-color, #0156DC);
		mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABMZJREFUaEPtWV1oHFUUPmd2Cg20oFBxNz5YIQ8WFCpa6IOiRUVFHxJaUWkEwc3cCStpgxZbUByhYkEhLTjs3NmUVlBQWrGFBZUqKNYHsaLgyz4UTKFkFuyDYEiz2Zm97g13wnUyv9nZxsDu2+6cc+/33XPmfuecRdjkH9zk+GFAYKMjmHsEDMNQS6XSQQAYB4DdjDEXEX9njJ1tNpsXDcNYypN0rgRqtdqdnuddQMS9ESAvt1qtl6ampq7nRSI3ArOzs3d7nvc9AOxMADdXKBQeK5fL1/IgkQuBWq32oOd5dUQsclAibY53Op2P+XdFUQ4yxgxEVAXo64qijE5MTPzaK4meCdi2/RRj7DwAbBNglro5P6pp2jcyOGF3AQC2xtllJdQTAcuyXkDEsxKoG4h4QNO0H8KA2Lb9qCC7QyIxrmnaF1mB+/brJmDb9puMsRP+QoyxOc/znqxUKlfjwJimOVIoFC51icvvyluEkPfWQ2JdBCil7wPAUWnDRqfTeWZycnIuDYhqtbpTUZSvAODe1ZNEPK5p2ttp/GWbTAQMw9haKpXOAMCL0iLfuq47VilUFrJsbprmNlVVvwSAJyQS5+fn51/OohWpCYgNzwHA01La1JvN5vNZNpRJ8gMpFovnEPE56fevHccZS7tmKgJcoDqdTh0AHpI2Ouk4zhHDMNwsJx+0Fcr9AQAclg7myvLy8lgawUskECFQBiHk3V6AB30ppe90fzOk31MJXiyBMIECAF3X9dN5gvfXsizrVQCwsgheJIG0ApU3kayCF0qAUvosAHB1XVFNxlhTVdUD5XL5p7wBZxC8NerOfdcQEDnfkMCnEqi8iYUI3pLruvcHhXINAUrpjHQjXG21WvvS3AZ5E+DrCcG7BAAjK6eNaGmaNhkrZJTSP6WSeC8h5Od+gEu7pqifeJnOP3OEkHuSCDDfwHGcLb3e82mBRtkJnWj7z7vX93+yJiyFVgkEjePAVKvVuxRFeQ0ARhljI9JVuOImegT+btVd1z1VqVSaacl1NSISUy4EbNvmDYsl9QRJ2Ja61esruq5/nmTIn/eVgOgJPksDJGiDiLwX+DTJt28ETNMsqqrKX3q/y+Ip8objON8FizFeDBYKhccRkfcQfhm90Gq1diXdcn0jEOgLGq7r7kkqq0VV+4tE4gQh5FhcFPpGwLKsPxDxPr65aNIvJqWDyGmu9Ly65Z8GIWTXRhFo+7eN67rbk07fBykao5v+7aTr+pYNIRAX2qRIZPHtWwplAREklMV3QCAqHbKc4iAC4gRyrYUGEYg41Szp1lMx93+NABeYldpmcXHx9unp6b9jXuJVWwC4gxByI+n+F0rMh7t/CSFb0HV9e5SfKD3+iRK9sAj8xv8aEg7luBEKpfRHAHhY2NY9z5tIqvMppTsYY2ekadxlQsgjUQRs2z7EGDspnl8hhOyRbcMIvN6t6z8URnzWf7Tdbp8OKxNs294vxuVpDj7UJqqGmpmZuW1oaGg/In7kZwQiHtY07VQsAVGn8CisTo7XjS5fx4bjOA8Ey/TQuVDY+DtfLJlXixzfR07meCSGh4cJY2ycMbY72ONmhpDdgf8dyxukTxzHMaOm1YnD3ez73lqPAYFbe95rd9v0EfgXsFbQT3YQwnYAAAAASUVORK5CYII=');
		-webkit-mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABMZJREFUaEPtWV1oHFUUPmd2Cg20oFBxNz5YIQ8WFCpa6IOiRUVFHxJaUWkEwc3cCStpgxZbUByhYkEhLTjs3NmUVlBQWrGFBZUqKNYHsaLgyz4UTKFkFuyDYEiz2Zm97g13wnUyv9nZxsDu2+6cc+/33XPmfuecRdjkH9zk+GFAYKMjmHsEDMNQS6XSQQAYB4DdjDEXEX9njJ1tNpsXDcNYypN0rgRqtdqdnuddQMS9ESAvt1qtl6ampq7nRSI3ArOzs3d7nvc9AOxMADdXKBQeK5fL1/IgkQuBWq32oOd5dUQsclAibY53Op2P+XdFUQ4yxgxEVAXo64qijE5MTPzaK4meCdi2/RRj7DwAbBNglro5P6pp2jcyOGF3AQC2xtllJdQTAcuyXkDEsxKoG4h4QNO0H8KA2Lb9qCC7QyIxrmnaF1mB+/brJmDb9puMsRP+QoyxOc/znqxUKlfjwJimOVIoFC51icvvyluEkPfWQ2JdBCil7wPAUWnDRqfTeWZycnIuDYhqtbpTUZSvAODe1ZNEPK5p2ttp/GWbTAQMw9haKpXOAMCL0iLfuq47VilUFrJsbprmNlVVvwSAJyQS5+fn51/OohWpCYgNzwHA01La1JvN5vNZNpRJ8gMpFovnEPE56fevHccZS7tmKgJcoDqdTh0AHpI2Ouk4zhHDMNwsJx+0Fcr9AQAclg7myvLy8lgawUskECFQBiHk3V6AB30ppe90fzOk31MJXiyBMIECAF3X9dN5gvfXsizrVQCwsgheJIG0ApU3kayCF0qAUvosAHB1XVFNxlhTVdUD5XL5p7wBZxC8NerOfdcQEDnfkMCnEqi8iYUI3pLruvcHhXINAUrpjHQjXG21WvvS3AZ5E+DrCcG7BAAjK6eNaGmaNhkrZJTSP6WSeC8h5Od+gEu7pqifeJnOP3OEkHuSCDDfwHGcLb3e82mBRtkJnWj7z7vX93+yJiyFVgkEjePAVKvVuxRFeQ0ARhljI9JVuOImegT+btVd1z1VqVSaacl1NSISUy4EbNvmDYsl9QRJ2Ja61esruq5/nmTIn/eVgOgJPksDJGiDiLwX+DTJt28ETNMsqqrKX3q/y+Ip8objON8FizFeDBYKhccRkfcQfhm90Gq1diXdcn0jEOgLGq7r7kkqq0VV+4tE4gQh5FhcFPpGwLKsPxDxPr65aNIvJqWDyGmu9Ly65Z8GIWTXRhFo+7eN67rbk07fBykao5v+7aTr+pYNIRAX2qRIZPHtWwplAREklMV3QCAqHbKc4iAC4gRyrYUGEYg41Szp1lMx93+NABeYldpmcXHx9unp6b9jXuJVWwC4gxByI+n+F0rMh7t/CSFb0HV9e5SfKD3+iRK9sAj8xv8aEg7luBEKpfRHAHhY2NY9z5tIqvMppTsYY2ekadxlQsgjUQRs2z7EGDspnl8hhOyRbcMIvN6t6z8URnzWf7Tdbp8OKxNs294vxuVpDj7UJqqGmpmZuW1oaGg/In7kZwQiHtY07VQsAVGn8CisTo7XjS5fx4bjOA8Ey/TQuVDY+DtfLJlXixzfR07meCSGh4cJY2ycMbY72ONmhpDdgf8dyxukTxzHMaOm1YnD3ez73lqPAYFbe95rd9v0EfgXsFbQT3YQwnYAAAAASUVORK5CYII=');
		mask-size: contain;
		-webkit-mask-size: contain;
		mask-repeat: no-repeat;
		-webkit-mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-position: center;
		pointer-events: none;
	}

	/* 订单图标 - 使用伪元素覆盖主题色 */
	.tabbar-item.active .tab-icon:has(.orders-icon)::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 28px;
		height: 28px;
		background: var(--primary-color, #0156DC);
		mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAcFJREFUaEPtWTtOxDAQtaWtUlFQUFJwkL3HIkEVKxVHYDlBaFLYFUhwj+32EhScJCaWIhQl9u7MeDAOOPX4zbz5eTyRYuWfXLn9IkigbduLqqp2QojLhCQ/lVKvGH1eAl3XXW02m6MQ4hoDxiErpbyt6/odiuUlYIx5sNY+Q0GY5fZKqScoppeA1vpxANg7EGvtQUp5gAJS5AYd20HHdjzLS8ARwXiEQmDqMKy+sxHAAmZPwBizs9beUAwNnZmmUCBlg90JFQGt9d3QmV44jYdihboTlsB3cUMVM8p5a5FMIJfuRCaQS3EXAow5voCC3A8lAiUCJzxQUmg+HUI8wplSEH3sRUyclbyzTnICMbOSb9ZJTmD0/hsxje7n7+HkBJzhYxRQb+m+7z+aplm8g3+FANH73mOFwL9so6tPoXIPTEKYvIjLPTAroOQR4Czg8VKcbkF4txLlUQ8IV0kh56TpAitmDQ5w+I9tJUK6s1i7h/7QuA30ubk+XwKhuX41KRTKGUhXoOR6jD7Uf+I/RSDr9TowpJzZAsGCjxIhtMhpE2LkKZnF1sIJo2qAunWItTy0tSARiDWG+zw6AtwGxOJ9AZzEfE+wKJ6HAAAAAElFTkSuQmCC');
		-webkit-mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAcFJREFUaEPtWTtOxDAQtaWtUlFQUFJwkL3HIkEVKxVHYDlBaFLYFUhwj+32EhScJCaWIhQl9u7MeDAOOPX4zbz5eTyRYuWfXLn9IkigbduLqqp2QojLhCQ/lVKvGH1eAl3XXW02m6MQ4hoDxiErpbyt6/odiuUlYIx5sNY+Q0GY5fZKqScoppeA1vpxANg7EGvtQUp5gAJS5AYd20HHdjzLS8ARwXiEQmDqMKy+sxHAAmZPwBizs9beUAwNnZmmUCBlg90JFQGt9d3QmV44jYdihboTlsB3cUMVM8p5a5FMIJfuRCaQS3EXAow5voCC3A8lAiUCJzxQUmg+HUI8wplSEH3sRUyclbyzTnICMbOSb9ZJTmD0/hsxje7n7+HkBJzhYxRQb+m+7z+aplm8g3+FANH73mOFwL9so6tPoXIPTEKYvIjLPTAroOQR4Czg8VKcbkF4txLlUQ8IV0kh56TpAitmDQ5w+I9tJUK6s1i7h/7QuA30ubk+XwKhuX41KRTKGUhXoOR6jD7Uf+I/RSDr9TowpJzZAsGCjxIhtMhpE2LkKZnF1sIJo2qAunWItTy0tSARiDWG+zw6AtwGxOJ9AZzEfE+wKJ6HAAAAAElFTkSuQmCC');
		mask-size: contain;
		-webkit-mask-size: contain;
		mask-repeat: no-repeat;
		-webkit-mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-position: center;
		pointer-events: none;
	}

	/* 交易图标 - 使用伪元素覆盖主题色 */
	.tabbar-item.active .tab-icon:has(.trading-icon)::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 28px;
		height: 28px;
		background: var(--primary-color, #0156DC);
		mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAoVJREFUaEPtmr2O00AQx3e0KSjuASiv4B3uJK6ggA4KSsQhDinKbJQGBBJ0HB1IIGgS7USRCOIQJQV0XEEBAt7hiit5gCsoYi/2aVeynHUSf6x3I+LW453/b8Y7O/IY2JpfsOb62QbAdwYXZoCIdpRSVwDggiehZ5zzX91u90eRfyvAcDjc4px/BIDrnoTn3R7PZrObg8HgLH/DCkBEXxljVwMRfy5DKfVFCHFjKcBkMrkcRdH3jOERY+zEB4xSahsADjK+dxHxd1bLXAaI6CFj7KWmngoh7vkQb3wS0fskgPtazxMhxItlAE8Tg0NtdIiIzzwDLNRjy8AGoMmMEZH/DIzH49tKqQ4ivisL5x2AiO4yxqZa+BtEfFAGwjuAjn5ais1VCsI7QKpaSvkaAO5XgQgCoA5EMABVIYICqALhDEBvzktlKoqxVUoJALi4yp5wApArjVUY5p4BgP1er/chf8MJgKU0NgFxYDvonACkanUWtptQHsfxSb/fn4u+9uO/lagD6SwDdUSVedYZQJ0qZAE4LWr0nABsqpD9HWq3CuUbtORw+pMcTrLM+21svVWhOl3mqqBO9kDWuWsI5wBVGrRVo9/qQeYqE61kwEQ0D1HUoAWZgQIIa2kMGsA0enEcz4oatOAByghcZtvqHlgmpsr9/w9ASvk4GSk919E6QsQ7VSLX1DNSyreZGcEjRHyVXXvu6/RoNNrlnP80RsmQYZoscNqUoJLrpB8NzmcD6cU538vPy6wjJinl54DmY0b/MSJeywegcMjX6XQ+hTInS+djURTdWnnIZyiJaI8xtpOMnLZKpr4Rc6XUXwD4lp+LLdwDjXhucZHNrwYtBtvqau0z8A/SbSFPGedPZQAAAABJRU5ErkJggg==');
		-webkit-mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAoVJREFUaEPtmr2O00AQx3e0KSjuASiv4B3uJK6ggA4KSsQhDinKbJQGBBJ0HB1IIGgS7USRCOIQJQV0XEEBAt7hiit5gCsoYi/2aVeynHUSf6x3I+LW453/b8Y7O/IY2JpfsOb62QbAdwYXZoCIdpRSVwDggiehZ5zzX91u90eRfyvAcDjc4px/BIDrnoTn3R7PZrObg8HgLH/DCkBEXxljVwMRfy5DKfVFCHFjKcBkMrkcRdH3jOERY+zEB4xSahsADjK+dxHxd1bLXAaI6CFj7KWmngoh7vkQb3wS0fskgPtazxMhxItlAE8Tg0NtdIiIzzwDLNRjy8AGoMmMEZH/DIzH49tKqQ4ivisL5x2AiO4yxqZa+BtEfFAGwjuAjn5ais1VCsI7QKpaSvkaAO5XgQgCoA5EMABVIYICqALhDEBvzktlKoqxVUoJALi4yp5wApArjVUY5p4BgP1er/chf8MJgKU0NgFxYDvonACkanUWtptQHsfxSb/fn4u+9uO/lagD6SwDdUSVedYZQJ0qZAE4LWr0nABsqpD9HWq3CuUbtORw+pMcTrLM+21svVWhOl3mqqBO9kDWuWsI5wBVGrRVo9/qQeYqE61kwEQ0D1HUoAWZgQIIa2kMGsA0enEcz4oatOAByghcZtvqHlgmpsr9/w9ASvk4GSk919E6QsQ7VSLX1DNSyreZGcEjRHyVXXvu6/RoNNrlnP80RsmQYZoscNqUoJLrpB8NzmcD6cU538vPy6wjJinl54DmY0b/MSJeywegcMjX6XQ+hTInS+djURTdWnnIZyiJaI8xtpOMnLZKpr4Rc6XUXwD4lp+LLdwDjXhucZHNrwYtBtvqau0z8A/SbSFPGedPZQAAAABJRU5ErkJggg==');
		mask-size: contain;
		-webkit-mask-size: contain;
		mask-repeat: no-repeat;
		-webkit-mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-position: center;
		pointer-events: none;
	}

	/* 理财图标 - 使用伪元素覆盖主题色 */
	.tabbar-item.active .tab-icon:has(.financial-icon)::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 28px;
		height: 28px;
		background: var(--primary-color, #0156DC);
		mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAn9JREFUWEftmTFoFEEUht9blsM7LBJQiJ2FATvTiI0BCwsLC8HS6kDmLZxgDiMoKBIUFIxcBA92FsHKwkKwSBHBIqCN2GgnmMJOQcEUYQl3yz5vZBZ2j7s4490mOZntlpv3z7dv/n2zbw5hwi6cMF74/4GjKLqUpukVRDxe4up8B4C1OI6Xms3mZn4eqwyHYfgQERdLBO2X3ojj+GQe2hg4DMMTiPhxF2GzqR4Q0c3sxgb4LiLe0oFrSZLUO53OdhkPUK1WLyLiU629QUSz1sBSyhYALKhARFwQQjwuA1ZptlqtqVqt9kvrbxLRtAMeZ7atMyylPIWI55n5YA7kDADMaUusM/NILyAifu12uy8ajYYqYYXLCniXS9d2r/JcEEK8zhMbA0spCQDCcS6vgdZWkiSz+UzbAL8FgNNqEmZe9TzvjcGE1kOY2WdmtVse1cGLRPQoE7IB/gEAh1RgkiRHBvnLmm5IgJTyGgAs659XiKj5L8Cq9k2pwEqlMl2v1wv7+LhglU4URVeZecUBjzOreS2XYefhPm85SzhLOEsAgJTS7XTDNh5XJVyVsKgS7XZ7xvf9bzrkJxEdHtg179VLh4jrvX7xVQaVpulZ1VPq+3dENL+vgP/yRRgQkZwI4F7XvhwEwfX8AxWOqvbKEgCgjgyULf5czLyFiKtE9L4/+/sFuNDT7WQRB2zaUu2009lk+AsAHFMBnudd9n3/pSmAzbg4jg/4vv8MAM6pOES8J4S4baLRb4n7AHDDJHCcY5h5LgiCTyaaBWB94vIhy7KJwKhjBpUuY0uogRr6jl6umVGBhsUz82fP854IIZ7bzGH8l4GNaJljHXCZ2VXavwERDTdLqdBkNgAAAABJRU5ErkJggg==');
		-webkit-mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAn9JREFUWEftmTFoFEEUht9blsM7LBJQiJ2FATvTiI0BCwsLC8HS6kDmLZxgDiMoKBIUFIxcBA92FsHKwkKwSBHBIqCN2GgnmMJOQcEUYQl3yz5vZBZ2j7s4490mOZntlpv3z7dv/n2zbw5hwi6cMF74/4GjKLqUpukVRDxe4up8B4C1OI6Xms3mZn4eqwyHYfgQERdLBO2X3ojj+GQe2hg4DMMTiPhxF2GzqR4Q0c3sxgb4LiLe0oFrSZLUO53OdhkPUK1WLyLiU629QUSz1sBSyhYALKhARFwQQjwuA1ZptlqtqVqt9kvrbxLRtAMeZ7atMyylPIWI55n5YA7kDADMaUusM/NILyAifu12uy8ajYYqYYXLCniXS9d2r/JcEEK8zhMbA0spCQDCcS6vgdZWkiSz+UzbAL8FgNNqEmZe9TzvjcGE1kOY2WdmtVse1cGLRPQoE7IB/gEAh1RgkiRHBvnLmm5IgJTyGgAs659XiKj5L8Cq9k2pwEqlMl2v1wv7+LhglU4URVeZecUBjzOreS2XYefhPm85SzhLOEsAgJTS7XTDNh5XJVyVsKgS7XZ7xvf9bzrkJxEdHtg179VLh4jrvX7xVQaVpulZ1VPq+3dENL+vgP/yRRgQkZwI4F7XvhwEwfX8AxWOqvbKEgCgjgyULf5czLyFiKtE9L4/+/sFuNDT7WQRB2zaUu2009lk+AsAHFMBnudd9n3/pSmAzbg4jg/4vv8MAM6pOES8J4S4baLRb4n7AHDDJHCcY5h5LgiCTyaaBWB94vIhy7KJwKhjBpUuY0uogRr6jl6umVGBhsUz82fP854IIZ7bzGH8l4GNaJljHXCZ2VXavwERDTdLqdBkNgAAAABJRU5ErkJggg==');
		mask-size: contain;
		-webkit-mask-size: contain;
		mask-repeat: no-repeat;
		-webkit-mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-position: center;
		pointer-events: none;
	}

	/* 个人中心图标 - 使用伪元素覆盖主题色 */
	.tabbar-item.active .tab-icon:has(.profile-icon)::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 28px;
		height: 28px;
		background: var(--primary-color, #0156DC);
		mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAl1JREFUaEPtmjFLHEEUx98wV1hYxj5FvoOCFhZaGYuUgoKBgzdwpBCFpNN0CSRg4R3z4CBChJQWiZUWForJd7CwN6VFilsmu7AHy7q3M7Mzs3ow1968mf/vzdv577w7BlP+YVOuHyLAU+9g7Q4Q0bxSapkxNtOi0AfO+e9ut3ttsmYlQL/fn+Wc/2CMvTaZJNCYi9Fo9KbX6z3UzV8JQETnALAUSJjxtEqpX0KIdSuA4XC4mCTJVSHoBABujVd1HKiUeskY2y5Ms4CIfyZN+2gHiGgXAL5kAelkx0KIt46arMOJ6HuatM1cwwchxGcbgP108EEecICIH60VOAYQkbGGqh0wDnbUOTE8AsQScqytZ1NCTZ08d//lPA9HiPiu1VMogJNPdOUgp1AIJ5/kyt4BfDq5iSt7B/Dt5DpXDgHg1Qh1J1IEKB9vuozZWoRuvtZ3gIjWAOA4B9lGxLM6qOcIcA8AL3LRfxFxLgIUM6DbMl0N6+KnvoR0CbA9FFp/iCNA6YrrfQeklO/TRtinPNMniLhlm/XieCnlt0KXYg8Rvxa/9w4wGAwWOOc340WyzkYq4K4hxKtxdyKL55wvlTt23gGyhaSUPwN09S4QcbWciCAA2YWm0+mc+eruZXeBJEk2qtqMQQDGWSKiJQCYTxtlszYlVLpSHiLiTqtXShuxVWN1Zhj0IXYVn8VHgNjYcqwjpxLy7aRNWHTuW/sQe3bSJvq17lsLENBJm8BUuq8WwLeTNlFe575aAFcnbSK48PL3jzF2Wfe7mDGAi5C2YuNfDdrKtPHL3FMLsl3/P1BoC09xhlvaAAAAAElFTkSuQmCC');
		-webkit-mask-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAl1JREFUaEPtmjFLHEEUx98wV1hYxj5FvoOCFhZaGYuUgoKBgzdwpBCFpNN0CSRg4R3z4CBChJQWiZUWForJd7CwN6VFilsmu7AHy7q3M7Mzs3ow1968mf/vzdv577w7BlP+YVOuHyLAU+9g7Q4Q0bxSapkxNtOi0AfO+e9ut3ttsmYlQL/fn+Wc/2CMvTaZJNCYi9Fo9KbX6z3UzV8JQETnALASSJjxtEqpX0KIdSuA4XC4mCTJVSHoBABujVd1HKiUeskY2y5Ms4CIfyZN+2gHiGgXAL5kAelkx0KIt46arMOJ6HuatM1cwwchxGcbgP108EEecICIH60VOAYQkbGGqh0wDnbUOTE8AsQScqytZ1NCTZ08d//lPA9HiPiu1VMogJNPdOUgp1AIJ5/kyt4BfDq5iSt7B/Dt5DpXDgHg1Qh1J1IEKB9vuozZWoRuvtZ3gIjWAOA4B9lGxLM6qOcIcA8AL3LRfxFxLgIUM6DbMl0N6+KnvoR0CbA9FFp/iCNA6YrrfQeklO/TRtinPNMniLhlm/XieCnlt0KXYg8Rvxa/9w4wGAwWOOc340WyzkYq4K4hxKtxdyKL55wvlTt23gGyhaSUPwN09S4QcbWciCAA2YWm0+mc+uruZXeBJEk2qtqMQQDGWSKiJQCYTxtlszYlVLpSHiLiTqtXShuxVWN1Zhj0IXYVn8VHgNjYcqwjpxLy7aRNWHTuW/sQe3bSJvq17lsLENBJm8BUuq8WwLeTNlFe575aAFcnbSK48PL3jzF2Wfe7mDGAi5C2YuNfDdrKtPHL3FMLsl3/P1BoC09xhlvaAAAAAElFTkSuQmCC');
		mask-size: contain;
		-webkit-mask-size: contain;
		mask-repeat: no-repeat;
		-webkit-mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-position: center;
		pointer-events: none;
	}

	/* 激活状态 */
	.tabbar-item.active .tab-text {
		color: var(--primary-color, #0156DC);
		font-weight: 500;
	}
</style>